import React from 'react';
import { Edit, ReferenceInput, SimpleForm, TextInput } from 'react-admin';
import { AutocompleteInput, ImageField } from 'react-admin';

import {
   Filter,
   TopToolbar,
   ImageInput,
   CloneButton,
   ShowButton,
   TabbedForm,
   FormTab,
   Toolbar,
   SaveButton,
   required,
   List,
   Show,
   RichTextField,
   SimpleShowLayout,
   Create,
   Datagrid,
   TextField,
   EditButton,
   DeleteButton,
   DeleteWithConfirmButton,
   BooleanInput,
   SelectInput,
   BooleanField,
   DateField,
   minLength
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { DateTimeInput } from 'react-admin';
import PostTitle from '../PostTitle';
import ListActions from '../ListActions';

const PublisherFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search by Name" source="name.en" alwaysOn />
        <ReferenceInput label="Authors" source="id" reference="favreads_authors" allowEmpty>
            <SelectInput optionText="name.en" />
        </ReferenceInput>
        <BooleanInput source="is_active" label="Active?" allowEmpty />
    </Filter>
);

export const PublisherList = props => (
	<List filters={<PublisherFilter />} actions={<ListActions />} {...props}>
       <Datagrid rowClick="edit">
		   <ImageField source="thumbnail" title="title"  label="Thumbnail"/>
            <TextField source="name.en" />
		    <RichTextField source="short_description.en" label="Description-English" />
            <BooleanField source="is_active" label="Is Active?" />
            <DateField source="created_at" />
           <ShowButton label="" />
		   <EditButton label="" />
		   <DeleteWithConfirmButton label="" redirect={false} />
       </Datagrid>
   </List>
);
const CustomToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
        <DeleteButton undoable={false} />
    </Toolbar>
);
const EditActions = ({ basePath, data, hasShow }) => (
    <TopToolbar>
        <CloneButton
            className="button-clone"
            basePath={basePath}
            record={data}
        />
        {hasShow && <ShowButton basePath={basePath} record={data} />}
    </TopToolbar>
);
export const PublisherEdit = props => (
   <Edit actions={<EditActions />} {...props}>
      <TabbedForm warnWhenUnsavedChanges>
	    <FormTab label="Summary">
           <TextInput disabled source="id"/>
			<TextInput source="thumbnail" fullWidth={true}/>
			<TextInput source="backdrop" fullWidth={true}/>
			<TextInput source="slug" fullWidth={true}/>
			<BooleanInput source="is_active"/>
		</FormTab>
		<FormTab label="Translations">
			<TextInput
				source="name.en"
				label="Title-English"
				fullWidth={true}
				validate={required()}
			/>
			<TextInput
				source="name.hi"
				label="Title-Hindi"
				fullWidth={true}
				validate={required()}
			/>
			<RichTextInput source="short_description.en" label="Summary-English" />
  		    <RichTextInput source="short_description.hi" label="Summary-Hindi" />
			<RichTextInput source="description .en" label="Description-English" />
  		    <RichTextInput source="description .hi" label="Description-Hindi" />
 		</FormTab>
	  </TabbedForm>
   </Edit>
);

export const PublisherShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name.en" />
	  <ImageField source="thumbnail" title="title" />
      <RichTextField source="short_description.en" />
    </SimpleShowLayout>
  </Show>
);

export const PublisherCreate = props => (
   <Create {...props}>
	<TabbedForm warnWhenUnsavedChanges>
	    <FormTab label="Summary">
           <TextInput disabled source="id"/>
			<TextInput source="thumbnail" fullWidth={true}/>
			<TextInput source="backdrop" fullWidth={true}/>
			<TextInput source="slug" fullWidth={true}/>
			<TextInput source="is_active"/>
		</FormTab>
		<FormTab label="Translations">
			<TextInput
				source="name.en"
				label="Name-English"
				fullWidth={true}
				validate={required()}
			/>
			<TextInput
				source="name.hi"
				label="Name-Hindi"
				fullWidth={true}
				validate={required()}
			/>
			<RichTextInput source="short_description.en" label="Summary-English" />
  		    <RichTextInput source="short_description.hi" label="Summary-Hindi" />
			<RichTextInput source="description.en" label="Description-English" />
  		    <RichTextInput source="description.hi" label="Description-Hindi" />
 		</FormTab>
	  </TabbedForm>
   </Create>
);